import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import CustomCard from '../../Scanners/components/CustomCard';

/**
 * Skeleton loader for Tabs section
 */
const TabsSkeleton = () => {
  const { theme } = useTheme();

  return (
    <>
      {/* Tab Headers */}
      <div className={`p-1 w-fit rounded ${theme === 'dark' ? 'bg-p400' : 'bg-p400'} mb-3`} style={{ height: '40px' }}>
        <div className="flex h-full gap-1">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-full w-32 bg-n200 rounded animate-pulse"></div>
          ))}
        </div>
      </div>

      {/* Tab Content Card */}
      <CustomCard style={{ height: '332px', padding: '16px' }}>
        <div className="space-y-3">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="flex items-center justify-between">
              <div className="h-4 w-32 bg-n200 rounded animate-pulse"></div>
              <div className="h-4 w-24 bg-n200 rounded animate-pulse"></div>
            </div>
          ))}
        </div>
      </CustomCard>
    </>
  );
};

export default TabsSkeleton;
